module.exports = __webpack_public_path__ + "static/media/pathway.0bacfb08.jpg";